var c = Object.defineProperty;
var i = Object.getOwnPropertySymbols;
var d = Object.prototype.hasOwnProperty, g = Object.prototype.propertyIsEnumerable;
var m = (t, e, r) => e in t ? c(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, l = (t, e) => {
  for (var r in e || (e = {}))
    d.call(e, r) && m(t, r, e[r]);
  if (i)
    for (var r of i(e))
      g.call(e, r) && m(t, r, e[r]);
  return t;
};
import { jsx as s } from "react/jsx-runtime";
import { useMemo as o } from "react";
const a = {
  small: "w-6 h-6 text-xs",
  medium: "w-8 h-8",
  large: "w-12 h-12 text-2xl"
}, f = (t) => {
  if (!t)
    return "?";
  const e = t.trim().split(" ");
  return e.length === 1 ? e[0].toUpperCase()[0] : e[0].toUpperCase()[0] + e[e.length - 1].toUpperCase()[0];
}, p = (t) => {
  const { image: e, size: r, name: n } = t, u = o(() => a[r || "medium"] || a.medium, [r]);
  return typeof e == "string" ? /* @__PURE__ */ s("img", { className: u, src: e, alt: n }) : e ? /* @__PURE__ */ s("image", {}) : /* @__PURE__ */ s("span", { children: f(n) });
}, w = (t) => {
  const { size: e, name: r } = t, n = o(() => a[e || "medium"] || a.medium, [e]);
  return /* @__PURE__ */ s(
    "div",
    {
      title: r,
      className: n + " flex items-center justify-center overflow-hidden text-center bg-gray-200 rounded-full text-neutral-600 dark:bg-neutral-600 dark:text-gray-50",
      children: /* @__PURE__ */ s(p, l({}, t))
    }
  );
};
export {
  w as A
};
